import { Transaction } from "./Links/IMAXA/IMAXAProtocol"
export class GameState {
	ID: number
	phase: number
	phaseSubID: number
	timeLeft: number
	totalTime: number
	winNumber: number
	jackpot:
		{
			enabled: number
			levels: Array<JackpotLevel>
			luckyNumber: number
			state: {
				luckyLevel?: number
				luckyNumber?: number
			}
		}
	HotNumbers: Array<number> = [];
	ColdNumbers: Array<number> = new Array;
	HistoryNumbers: Array<number[] | number> = [];
	DoubleZero: boolean = false;
	Balance: Array<number> = [];
	Transactions: Array<Transaction> = [];

	SetHistoryNumbers(history: Array<number[] | number>) {
		this.HistoryNumbers = history;
		let numbersCount: NumberData[] = new Array<NumberData>(this.DoubleZero ? 38 : 37);

		//initial fill of 0's
		for (let n = 0; n < numbersCount.length; n++)
			numbersCount[n] = { num: n, count: 0 };

		let hotNumbers: Array<number> = new Array<number>();
		let coldNumbers: Array<number> = new Array<number>();

		//count how many times each number has fallen and put counters in new array which index is the number representing its count
		history.forEach(element => {
			let currentNum: NumberData;
			if ((element as number[]).length) {
				currentNum = numbersCount.find(el => el.num == element[1])
				if (currentNum)
					currentNum.count++;
			} else {
				let currentNum = numbersCount[(element as number)];
				currentNum.count++;
			}
		});

		numbersCount.sort(() => .5 - Math.random());//randomly mix them around before sorting , so colds are not always 0,1,2,3,4 at start
		numbersCount.sort((a, b) => a.count - b.count) // sort min to max

		//fill cold numbers
		for (let i = 0; i < 5; i++) {
			coldNumbers.push(numbersCount[i].num)
		}

		//fill hot numbers
		for (let i = numbersCount.length - 1; i > numbersCount.length - 6; i--) {
			if (numbersCount[i].count == 0)
				break;
			hotNumbers.push(numbersCount[i].num)
		}

		this.HotNumbers = hotNumbers;
		this.ColdNumbers = coldNumbers;
	}
}

export type JackpotLevel = {
	level: number,
	pot: number,
	status: string
}

export type NumberData = {
	num: number,
	count: number
};
